/**
 * Zeilenfolge nach Wohnungsverbund: die Gesamtwohnung, darunter eingerückt ihre Zimmer. Die
 * Zuordnung kommt aus der Objektwahl (`wholeFlatPropertyId`, dieselbe Stellung wie `flatFamily`
 * der Belegung); ein Zimmer, dessen Gesamtwohnung nicht in der Liste steht, bleibt eine eigene Zeile.
 */
export interface FamilyOrder<T> {
  rows: T[];
  /** Zimmer, deren Gesamtwohnung direkt darüber steht. */
  children: ReadonlySet<string>;
}

export function orderByFamily<T extends { propertyId: string }>(
  apartments: readonly T[],
  wholeFlatOf: ReadonlyMap<string, string>,
): FamilyOrder<T> {
  const present = new Set(apartments.map((apartment) => apartment.propertyId));
  const isChild = (id: string) => {
    const parent = wholeFlatOf.get(id);
    return parent !== undefined && parent !== id && present.has(parent);
  };
  const rows: T[] = [];
  for (const apartment of apartments) {
    if (isChild(apartment.propertyId)) continue;
    rows.push(apartment);
    rows.push(
      ...apartments.filter(
        (room) =>
          isChild(room.propertyId) && wholeFlatOf.get(room.propertyId) === apartment.propertyId,
      ),
    );
  }
  return {
    rows,
    children: new Set(apartments.map((a) => a.propertyId).filter(isChild)),
  };
}
